export class AudioRandomizer {
    setRandomness(audio, audioId) {
        if (!audio.howl)
            return;
        if (audio.audioObject.startOnRandomPlace) {
            audio.howl.seek(this.getRandomPlace(audio), audioId);
        }
        if (audio.audioObject.volumeRandom > 0) {
            audio.howl.volume(this.getRandomVolume(audio), audioId);
        }
        if (audio.audioObject.rateRandom > 0) {
            audio.howl.rate(this.getRandomRate(audio), audioId);
        }
    }
    getRandomPlace = (audio) => {
        if (!audio.howl)
            return 0;
        return Math.round(Math.floor(Math.random() * audio.howl.duration()));
    };
    getRandomFiles(randomCount, files) {
        const result = [];
        for (let i = 0; i < randomCount; i++) {
            const file = files.splice(Math.floor(Math.random() * files.length), 1)[0];
            if (file)
                result.push(file);
        }
        return result;
    }
    getRandomDelay = (audio) => {
        const { randomDelayBeforeStartTo, randomDelayBeforeStartFrom } = audio.audioObject;
        return Math.floor(Math.random() * (randomDelayBeforeStartTo - randomDelayBeforeStartFrom)) +
            randomDelayBeforeStartFrom;
    };
    getRandomVolume = (audio) => Number((Math.random() * audio.audioObject.volumeRandom).toFixed(3));
    getRandomRate = (audio) => Math.round((Math.random() * (audio.audioObject.rateRandom - 0.5) + 0.5) * 10) / 10;
    getRandomIndex(availableIndices) {
        return availableIndices[Math.floor(Math.random() * availableIndices.length)];
    }
    getRandomSpriteName(availableSpriteNames) {
        return availableSpriteNames[Math.floor(Math.random() * availableSpriteNames.length)];
    }
}
//# sourceMappingURL=AudioRandomizer.js.map